import { IToDoItem } from 'app/shared/model/to-do-item.model';
import { IUser } from 'app/shared/model/user.model';

export interface IFolder {
  id?: number;
  name?: string | null;
  toDoItems?: IToDoItem[] | null;
  user?: IUser;
}

export const defaultValue: Readonly<IFolder> = {};
